/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_uc_area_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How many acres are in a hectare?`)
};

const es_uc_area_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Cuántos acres hay en una hectárea?`)
};

const de_uc_area_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wie viele Acres hat ein Hektar?`)
};

const nl_uc_area_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hoeveel acres zitten in een hectare?`)
};

const fr_uc_area_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Combien d'acres y a-t-il dans un hectare ?`)
};

const it_uc_area_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quanti acri ci sono in un ettaro?`)
};

const pt_br2_uc_area_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quantos acres tem em um hectare?`)
};

const pt_uc_area_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quantos acres existem num hectare?`)
};

const ja_uc_area_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1ヘクタールには何エーカーありますか?`)
};

const zh_uc_area_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`[pending translation B]`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const uc_area_faq2_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.uc_area_faq2_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("uc_area_faq2_q", locale)
	if (locale === "en") return en_uc_area_faq2_q(inputs)
	if (locale === "es") return es_uc_area_faq2_q(inputs)
	if (locale === "de") return de_uc_area_faq2_q(inputs)
	if (locale === "nl") return nl_uc_area_faq2_q(inputs)
	if (locale === "fr") return fr_uc_area_faq2_q(inputs)
	if (locale === "it") return it_uc_area_faq2_q(inputs)
	if (locale === "pt-BR") return pt_br2_uc_area_faq2_q(inputs)
	if (locale === "pt") return pt_uc_area_faq2_q(inputs)
	if (locale === "ja") return ja_uc_area_faq2_q(inputs)
	return zh_uc_area_faq2_q(inputs)
};